module.exports = __webpack_public_path__ + "img/me.265479de.jpeg";